import { render } from "./AyudaAviso.vue?vue&type=template&id=0b5808ae&scoped=true"
import script from "./AyudaAviso.vue?vue&type=script&lang=js"
export * from "./AyudaAviso.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=0b5808ae&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5808ae"]])

export default __exports__